/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingInformationBatchResponse {
    getFixupPrototypeFunction() { return BillingInformationBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<BillingInformationBatchResponse>): BillingInformationBatchResponse {
        let obj = Object.assign(new BillingInformationBatchResponse(), model);
        BillingInformationBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingInformationBatchResponse>): BillingInformationBatchResponse {
        if (!model) return null;
        return BillingInformationBatchResponse.newInstance(<BillingInformationBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingInformationBatchResponse) {
        if (!obj) return;

        models.BillingInformationBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingInformationBatchResponse): boolean {
        Object.setPrototypeOf(obj, BillingInformationBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.BillingInformationBase.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.BillingInformationBase; };

}
